export default function TimeCell({ text }: { text: string }) {
  return (
    <div className="w-full h-20 px-4 flex flex-col bg-white items-center justify-center border shrink-0">
      <p className="text-sm pb-4 whitespace-nowrap">{text}</p>
      <p className="text-sm whitespace-nowrap">{text.replace('00', '30')}</p>
    </div>
  );
}
